export const API_CORE_URL = process.env.REACT_APP_API_CORE_URL;
export const API_URL = process.env.REACT_APP_API_URL;
export const WEB_APP = process.env.REACT_APP_WEB_APP;

// El estado owner puede guardar el usuario como objeto (isLoggedIn desenvuelve
// data[0]) o como array [{...}] (login guarda la respuesta cruda). getUser
// normaliza ambos shapes al objeto usuario para consumo consistente.
export const getUser = (user) => (Array.isArray(user) ? user?.[0] : user) ?? null;

// Punto unico de interceptacion del post-login: se lleva al usuario al selector
// de workspaces (/account/select) en vez de redirigir directo a WEB_APP solo cuando
// el usuario esta enrolado en mas de un workspace. Los campos multi-workspace
// (workspacesId) NO existen si el usuario no es multi-workspace -> optional chaining.
export const shouldSelectWorkspace = (user) => (getUser(user)?.workspacesId?.length ?? 0) > 1;

